import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="rating"
export default class extends Controller {
  static targets = ["input", "star"]

  select(event) {
    this.inputTarget.value = event.currentTarget.dataset.ratingValue
    this.updateStars(this.inputTarget.value)
  }

  preview(event) {
    this.updateStars(event.currentTarget.dataset.ratingValue)
  }

  reset() {
    this.updateStars(this.inputTarget.value)
  }

  updateStars(rating) {
    this.starTargets.forEach((star) => {
      star.classList.toggle("text-blue-600", Number(star.dataset.ratingValue) <= Number(rating))
      star.classList.toggle("text-gray-300", Number(star.dataset.ratingValue) > Number(rating))
    })
  }
}
